import { Action } from '../../types';

export enum Actions {
    UPDATE_SEARCH_PHRASE = 'CARRIER_LIST_UPDATE_SEARCH_PHRASE',
    UPDATE_COMPLIANT_STATUS = 'CARRIER_LIST_UPDATE_COMPLIANT_STATUS',
}

export const setSearchPhrase = (searchPhrase: string): Action => {
    return {
        type: Actions.UPDATE_SEARCH_PHRASE,
        payload: searchPhrase,
        error: null,
    };
};

export const setCompliantStatus = (compliantStatus: string): Action => {
    return {
        type: Actions.UPDATE_COMPLIANT_STATUS,
        payload: compliantStatus,
        error: null,
    };
};
